export default {
  common: {
    name: 'Name',
    player: 'Player',
    username: 'Username',
    password: 'Password',
    unlogged: 'You must be logged in to access this part of the website.'
  },
  buttons: {
    disconnect: 'Disconnect',
    close: 'Close',
    finish: 'Finish',
    login: 'Login',
    register: 'Register'
  },
  nav: {
    feed: 'Feed',
    leaderboard: 'Leaderboard',
    matchs: 'Matchs',
    tournaments: 'Tournaments',
    rules: 'Rules',
    about: 'About',
    guild: 'Guild',
    unlogged: 'Sign in/Register',
    logged: 'My account',
    newMatchButton: 'New match'
  },
  banners: {
    feed: {
      title: {
        1: 'S o c i a l i t i e s'
      },
      subtitle: {
        1: 'What\'s new today?'
      }
    },
    leaderboard: {
      title: {
        1: 'Check your ranking.',
        2: 'Are you even ranked?'
      },
      subtitle: {
        1: 'Will you beat your friends today?'
      }
    },
    home: {
      title: {
        1: 'Welcome home, player!'
      },
      subtitle: {
        1: 'Fresh news'
      }
    },
    tournaments: {
      title: {
        1: 'Tournaments'
      },
      subtitle: {
        1: 'Where real skills are shown.',
        2: 'Become the best.'
      }
    },
    matchs: {
      title: {
        1: 'Matchs'
      },
      subtitle: {
        1: ''
      }
    },
    match: {
      title: {
        1: 'Match'
      },
      subtitle: {
        1: ''
      }
    },
    rules: {
      title: {
        1: 'Rules'
      },
      subtitle: {
        1: 'Standards and details of Gobelet-Pong',
        2: 'How do I do?'
      }
    },
    about: {
      title: {
        1: 'About'
      },
      subtitle: {
        1: 'Who are we?'
      }
    },
    guild: {
      title: {
        1: 'Guild'
      },
      subtitle: {
        1: 'One for all!'
      }
    },
    logged: {
      title: {
        1: 'This is your base.'
      },
      subtitle: {
        1: 'Is everything ok?'
      }
    }
  },
  pages: {
    loginRegister: {
      login: {
        title: 'Login',
        subtitle: 'Fill your credentials below to connect'
      },
      register: {
        title: 'Register',
        subtitle: 'Don\'t have an account yet? There you go!'
      }
    },
    rules: {
      content: {
        equipment: {
          title: 'Equipment',
          table: 'A Ping-pong table',
          paddle: 'Paddles',
          ball: 'A ball',
          gob: '2 gobs'
        },
        preparation: {
          title: 'Field preparation',
          above: 'Above view',
          side: 'Side view'
        },
        goal: {
          title: 'The goal',
          description: 'Make the opponent\'s gob fall.'
        },
        rules: {
          title: 'Rules',
          unit: 'A unit correspond to the gobelet basis diameter.',
          points: {
            standard: {
              presentation: 'A "standard" point is a normal Ping-pong point.',
              effect: 'When a standard point is loose, the gobelet back one unit.'
            },
            slide: {
              presentation: ' A "slide" happens when the gobelet is touched and slide on the table.',
              effect: 'When a slide happens, replace the gobelet onto the central line, as far as the gobelet gone.'
            }
          },
          statusquo: {
            presentation: 'A "Status-quo" happens when the ball touch the gobelet and it doesn\'t move, or stay in its unit.',
            effect: {
              first: 'After a "Status-quo", nothing happens.',
              second: 'No point is accounted, but if the next point is standard, the loosing gobelet will back two units instead of one.'
            }
          },
          bdg: 'When the gobelet is at the end of the table, next standard point is decisive.',
          preparation: {
            title: 'Before the match',
            first: 'Before starting the match, players play 3 standard points.',
            second: 'The winner win the first service.'
          },
          services: {
            title: 'Services',
            first: 'Service owner change every turn.',
            second: 'When a player fail its service, its gobelet back one unit.',
            third: 'A gobelet hit at service is not accounted (to avoid players targetting). Restart the service. If this happens 3 times in a row, service is considered failed.'
          },
          gameplay: {
            title: 'Gameplay',
            neverTooLate: 'A match is not finished until the gobelet fall, meaning even a player in a bad situation, the match can totally change by aiming correctly.',
            strategy: ' Strategy is present. The players can decide to make standard points or aiming the gobelet to hit it.La stratégie est très présente. Aiming make the player focus on this goal and not simply try to make a point.',
            levels: 'Matchs are more likely to meet players with different levels, since anyone can aim and make the difference, even if the opponent is a correct Ping-pong player.'
          }
        }
      }
    },
    about: {
      content: {
        welcome: 'Welcome!',
        presentation: 'We created this website to show the world the Gobelet-pong, and allow its players to be part of the experience.',
        founders: {
          alexis: 'No one can counter my skills.',
          thomas: 'Intercontinental Gobelet-Pong champion, on Supinfo Tours campus only.',
          victor: 'I always lose :('
        }
      }
    }
  },
  events: {
    title: 'Events',
    nothing: 'Nothing planned.'
  },
  footer: {
    slogan: 'Gobelet-Pong is a sport.',
    data: 'We don\'t store any personal data',
    contact: 'Any question? Contact'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js